export const DEFAULT_ELIGIBILITY_STATUS = { value: 'NOT_APPLICABLE', label: 'Not Applicable' }
export const DEFAULT_OVERALL_STATUS = { value: 'CREATED', label: 'Created' }
